export function getDirtyFields(dirtyFields: object | boolean, allValues: object): object {
  if (dirtyFields === true || Array.isArray(dirtyFields)) return allValues;
  if (dirtyFields === false) return [];

  const filterFalseValues = (obj: object): object => {
    if (Array.isArray(obj)) {
      const filteredArray = obj.filter((value: object | boolean) => value !== false);
      return filteredArray.map((value: object | boolean) => filterFalseValues(value as object));
    }
    if (typeof obj === 'object' && obj !== null) {
      const filteredObj: Record<string, object> = {};
      for (const [key, value] of Object.entries(obj)) {
        if (value !== false) {
          const filteredValue = filterFalseValues(value as object);
          if (typeof filteredValue === 'object' && Object.keys(filteredValue).length === 0) {
            continue; // Skip adding empty objects
          }
          filteredObj[key] = filteredValue;
        }
      }
      return filteredObj;
    }
    return obj;
  };

  const filteredDirtyFields = filterFalseValues(dirtyFields);

  return Object.fromEntries(
    Object.keys(filteredDirtyFields).map((key) => [
      key,
      getDirtyFields(
        filteredDirtyFields[key as keyof typeof filteredDirtyFields],
        allValues[key as keyof typeof allValues]
      ),
    ])
  );
}
